import { render, staticRenderFns } from "./IntegerFieldReadonly.vue?vue&type=template&id=220cec94&scoped=true"
import script from "./IntegerFieldReadonly.vue?vue&type=script&lang=ts"
export * from "./IntegerFieldReadonly.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220cec94",
  null
  
)

export default component.exports